<template>
  <div class="center-warp">
    <div class="inner d-flex-between">
      <div class="left-menu">
        <div v-for="(item,index) in menuList" :class="menuIndex == index ? 'on':''" @click="menuIndex = index">{{ item }}</div>
      </div>
      <PersonalData v-if="menuIndex == 0" />
      <Account v-if="menuIndex == 1" />
      <Help v-if="menuIndex == 2" />
      <Privacy v-if="menuIndex == 3" />
      <UserAgreement v-if="menuIndex == 4" />
      <AboutUs v-if="menuIndex == 5" />
    </div>
  </div>
</template>

<script>
import PersonalData from './Personal_data'
import Account from './Account'
import Help from './Help'
import Privacy from './Privacy'
import UserAgreement from './UserAgreement'
import AboutUs from './AboutUs'
export default {
  name: "index",
  components:{
    PersonalData,
    Account,
    Help,
    Privacy,
    UserAgreement,
    AboutUs
  },
  data(){
    return{
      menuIndex:0,
      menuList:[
        '个人资料',
        '账号管理',
        '帮助中心',
        '隐私政策',
        '用户协议',
        '关于我们',
      ]
    }
  }
}
</script>

<style scoped src="../../assets/css/user_center.css"></style>
<style>
.help-detail-right img{
  max-width: 764px;
  margin: 10px 0;
}
.help-detail-right p{
  margin: 0;
}
</style>
